import { right as a, chainW as f, left as i, tryCatch as r } from "fp-ts/lib/TaskEither.js";
import { pipe as n } from "fp-ts/lib/function.js";
function c(e, o) {
  return n(
    r(
      () => fetch(e, o),
      (t) => new Response(`fetch failed: ${t}`, {
        status: 0,
        statusText: `fetch failed: ${t}`
      })
    ),
    f((t) => t.ok ? a(t) : i(t))
  );
}
function u(e, o) {
  return n(
    c(e, o),
    f(
      (t) => r(
        () => t.json(),
        (s) => Error(`failed to parse response JSON: ${s}`)
      )
    )
  );
}
export {
  c as safeFetch,
  u as safeFetchJson
};
